import { User } from "src/features/users/types/user.entity";
import { UserTransaction } from "../../types/user-transaction.entity";
import React from "react";
import { Amount } from "src/components/Amount";
import { Badge } from "../transactions-table/badge";
import { formatScreamingSnakeCase } from "src/utils/util";
import { transactionStatusStyles, transactionTypeStyles } from "../../utils/transaction-style";
import { displayDate } from "src/utils/dateHandler.util";
import { checkIsTransactionRefundable } from "../../utils/transaction-actions";
import { Button } from "src/components/Form/button";
import { RefundModal } from "../refund-session-transaction/refund-modal";
import { useModal } from "src/components/modal/use-modal";

type Props = {
  transactions: UserTransaction[];
  users: Record<string, Partial<User>>;
  showRefundAction?: boolean;
  excludeRefundForUsersIds?: string[];
};

export const TransactionTableWithUsers: React.FC<Props> = ({
  transactions,
  users,
  showRefundAction = false,
  excludeRefundForUsersIds = [],
}) => {
  const refundModal = useModal<UserTransaction>();

  const refundTransaction = (transaction: UserTransaction) => {
    refundModal.open(transaction);
  };
  return (
    <div>
      <div className="overflow-x-auto mb-6">
        <table className="min-w-full border border-gray-200 divide-y divide-gray-200">
          <thead className="bg-gray-800 text-white text-center">
            <tr>
              <th className="px-4 py-3">User Photo</th>
              <th className="px-4 py-3">User Name</th>
              <th className="px-4 py-3">Amount</th>
              <th className="px-4 py-3">Type</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Date</th>
              {showRefundAction && <th className="px-4 py-3">Refund</th>}
            </tr>
          </thead>

          <tbody>
            {transactions.length === 0 && (
              <tr className="text-center">
                <td colSpan={6} className="px-4 py-3">
                  No User Transactions
                </td>
              </tr>
            )}

            {transactions.map((tx) => (
              <tr key={tx.id} className="text-center odd:bg-white even:bg-gray-50 hover:bg-gray-100">
                <td className="px-4 py-3 border-t border-gray-200">
                  <img
                    src={users[tx.userId]?.pictureURL ?? "/deleted-user.png"}
                    width="50"
                    height="50"
                    alt={`${users[tx.userId]?.name} avatar`}
                    className="rounded-full object-cover"
                  />
                </td>
                <td className="px-4 py-3 border-t border-gray-200">{users[tx.userId]?.name ?? "Deleted User"}</td>
                <td className="px-4 py-3 border-t border-gray-200">
                  <Amount amount={tx.amount} currency={tx.currency} />
                </td>
                <td className="px-4 py-3 border-t border-gray-200">
                  <Badge label={formatScreamingSnakeCase(tx.type)} classes={transactionTypeStyles[tx.type]} />
                </td>
                <td className="px-4 py-3 border-t border-gray-200">
                  <Badge label={formatScreamingSnakeCase(tx.status)} classes={transactionStatusStyles[tx.status]} />
                </td>
                <td className="px-4 py-3 border-t border-gray-200">{displayDate(tx.createdAt)}</td>
                {showRefundAction && (
                  <td className="px-4 py-3 border-t border-gray-200">
                    {checkIsTransactionRefundable(tx) &&
                    !excludeRefundForUsersIds.includes(tx.id) &&
                    users[tx.userId] ? (
                      <Button type="button" onClick={() => refundTransaction(tx)}>
                        Refund
                      </Button>
                    ) : (
                      "__"
                    )}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {refundModal.isOpen && <RefundModal transaction={refundModal.data!} close={() => refundModal.close()} />}
    </div>
  );
};
